module.exports = __webpack_public_path__ + "static/media/Piercing-nose-nostrilsymmetry.76961159.png";